import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "E:/workspaces/shop-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * 订单列表
 * @author shendeying
 */
import BackEventMixins from '~/mixins/back-event-mixins';
import config from '$config';
import api from 'api/order';
import { mapGetters } from 'vuex';
import { GET_SCREEN } from '$getters';
export default {
  name: 'page-order-list',
  mixins: [BackEventMixins],
  data: function data() {
    return {
      currentType: null,
      pageConfig: {
        page: 0,
        size: 10,
        status: 0
      },
      list: [],
      fetchFun: api.findPageOrder
    };
  },
  computed: _objectSpread({
    fileURL: function fileURL() {
      return config.fileURL;
    }
  }, mapGetters({
    screen: GET_SCREEN
  })),
  watch: {
    currentType: function currentType(val, oldVal) {
      if (oldVal) {
        this.query(val);
      }
    }
  },
  methods: {
    flushList: function flushList() {
      this.$refs.list.flushList();
    },
    fetchData: function fetchData() {
      this.$refs.list.fetchData();
    },
    query: function query(index) {
      this.pageConfig.status = index;
      this.flushList();
    },

    /**
     * 跳转到订单详情页
     * 查看详情 view
     * 去支付   toPay
     * 取消订单 applyCancel
     * 退货     return
     * 确认收货 confirmReceipt
     * 删除订单 applyDelete
     */
    handleDetail: function handleDetail(id, to) {
      this.$router.push({
        path: '/orderDetail',
        query: {
          to: to,
          id: id
        }
      });
    },
    // 申请开票 applyInvoice
    handleinvoiceApply: function handleinvoiceApply(id) {
      this.$router.push({
        name: 'invoiceApply',
        query: {
          id: id
        }
      });
    },
    // 再来一单
    handleMore: function handleMore(id) {
      this.$router.push({
        path: '/shoppingCart',
        query: {
          id: id
        }
      });
    },
    backFun: function backFun() {
      this.$router.push({
        path: '/my'
      });
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      // console.log('vm.$route.query: ', vm.$route.query)
      if (vm.$route.query && vm.$route.query.status) {
        // 从我的页面直接跳到对应分类的订单列表
        vm.currentType = vm.$route.query.status;
      } else if (vm.$route.query && vm.$route.query.do && vm.$route.query.do === 'hasPayed') {
        // 从支付完成的订单详情页返回订单列表
        vm.currentType = 3;
      } else {
        // 订单详情页一般回退
        vm.flushList();
      }
    });
  },
  mounted: function mounted() {},
  components: {}
};